import { profilesIds } from '../constants/profiles-ids';
import { ILoggedUser } from '../interfaces/i-logged-user';
import { IProfileLisItem } from '~/modules/profiles/interfaces/i-profile-list-item';

type ProfileLike = IProfileLisItem | null | undefined;

const normalizeRequiredPermissions = (
  permissions: string | string[]
): string[] =>
  (Array.isArray(permissions) ? permissions : [permissions])
    .map((permission) => String(permission || '').trim())
    .filter(Boolean);

export const profileHasPermission = (
  profile: ProfileLike,
  requiredPermissions: string | string[]
): boolean => {
  const permissions = (profile?.permissions || [])
    .map((permission) => String(permission || '').trim())
    .filter(Boolean);

  if (permissions.includes('full')) return true;

  const normalizedRequired =
    normalizeRequiredPermissions(requiredPermissions);

  return normalizedRequired.some((permission) =>
    permissions.includes(permission)
  );
};

export const isAdminProfile = (profile: ProfileLike): boolean => {
  return (
    profile?.id === profilesIds.ADMIN ||
    (profile?.permissions || []).includes('full')
  );
};

export const isAdminUser = (user?: ILoggedUser | null): boolean => {
  return Boolean(user && !user.employeeId && isAdminProfile(user.profile));
};
